var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStatusPremium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "6.8 8.48 0 8.48 4.95 3.48 6.8 8.48",
    fill: "#00aaf0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.99 22.52 0 8.48 6.8 8.48 11.99 22.52",
    fill: "#0096dc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.95 3.48 11.99 22.52 19.03 3.48 4.95 3.48",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.18 8.48 23.98 8.48 19.03 3.48 17.18 8.48",
    fill: "#a5e9ff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.99 22.52 23.98 8.48 17.18 8.48 11.99 22.52",
    fill: "#87daff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.99 3.48 11.99 3.48 6.8 8.48 17.18 8.48 11.99 3.48",
    fill: "#87daff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.18,
    y1: 8.48,
    x2: 17,
    y2: 8.48,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusPremium);
export default __webpack_public_path__ + "static/media/icon-status-premium.a15e36be360923bc4cec6f2969df865f.svg";
export { ForwardRef as ReactComponent };